import * as React from "react";
const SvgZoomOutRegular = (props) => React.cloneElement(/* @__PURE__ */ React.createElement("svg", { fill: "none", height: 24, viewBox: "0 0 24 24", width: 24, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m18.5 11.25c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-13c-.41421 0-.75-.3358-.75-.75s.33579-.75.75-.75z", fill: "currentColor" })), {
  className: ["svg-icon", "ZoomOutRegular", props.className].filter(Boolean).join(" ")
});
export default SvgZoomOutRegular;
